<template lang="pug">
    .modal.is-active
        .modal-background(@click="$emit('close')")
        .modal-content
            .box
                Teaser(:teaser="data")
                    template(slot="booking-link" v-if="activeBooking && !forceShowForm")
                        a(href="#" @click.stop.prevent="showForm = !showForm") Anmelden
                //- Render form if event.booking !== 'none'
                //- and if member_limit(_per_slot) is not bigger than the actual bookings.length
                //- and if the slot is not in the past
                transition(name="slide-decent-vertical")
                    EventForm(
                        v-if="activeBooking && (showForm || forceShowForm)"
                        :data="data"
                        size="small"
                        @success="$emit('success')"
                    )
        button.modal-close.is-large(aria-label="close" @click="$emit('close')")
</template>

<script>

import _ from 'lodash'

import Teaser from './Teaser'
import EventForm from './EventForm'

import { isPast } from 'date-fns'
import { timestamp2date } from '@/filters';

export default {
    name: 'EventFormModal',
    props: {
        data: {
            type: Object,
            required: true,
        },
        forceShowForm: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        showForm: false,
    }),
    components: {
        Teaser,
        EventForm
    },
    computed: {
        restriction() {
            return _.get(this.data.event, 'restriction') || 'none'
        },
        booking() {
            return _.get(this.data.event, 'booking') || 'none'
        },
        activeBooking() {
            let active = true

            if (active && this.booking === 'none') active = false
            if (active && this.restriction !== 'none') active = false

            const limit = this.data.member_limit || this.data.event.member_limit_per_slot
            if (active && limit && limit <= this.data.bookings.length) active = false

            if (active && isPast(timestamp2date(this.data.start_at))) active = false

            return active
        }
    },
    beforeMount() {
        document.documentElement.classList.add('is-clipped');
    },
    beforeDestroy() {
        document.documentElement.classList.remove('is-clipped');
    }
}
</script>

<style lang="sass" scoped>
.box::v-deep
    .row-teaser
        .image
            flex-basis: 240px
            a
                max-width: 320px
                display: block
                margin: 0 auto
        figure.date
            .month
                font-size: 1.4rem
            .day
                font-size: 3rem
        h3
            font-size: 1.2rem !important
            .small
                font-size: .7em
        .content, .link
            font-size: .85em
</style>
